import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { UserOnbording as USER_ONBORDING } from 'Components/Api/MorePayOnboardingAPI';
import { SelectUserByUserID as USER_SELECT_BY_USER_ID } from 'Components/Api/UsersApi';
import { useHistory } from 'react-router';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { MATM_Onboarding } from 'Components/Helper/Messages';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import {
    GetServiceCharge as SELECT_CHARGE,
    Deduct as DEDUCT_CHARGE
} from 'Components/Api/ServiceChargeDeductionAPI';
import {
    Container,
    Grid,
    Paper,
    Button,
    Box,
    TextField,
    CircularProgress
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);
export const UserOnboarding = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [PanImage, setPanImage] = useState('');
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [AadhaarFrontImage, setAadhaarFrontImage] = useState('');
    const [AadhaarBackImage, setAadhaarBackImage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [UserObj, setUserObj] = useState({
        UserID: 0,
        Name: '',
        ShopName: '',
        Area: '',
        City: '',
        PinCode: '',
        Email: '',
        Address: '',
        MobileNumber: '',
        PanNumber: '',
        AadhaarNumber: '',
        Area: '',
        PanDocument: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },
        AadhaarFrontDocument: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        },
        AadhaarBackDocument: {
            Name: '',
            Size: '',
            Type: '',
            Data: ''
        }
    });
    const getCharge = async () => {
        var requestObj = {
            ServiceID: MATM_Onboarding
        };
        var request = JSON.stringify(requestObj);
        const response = await SELECT_CHARGE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        var data = JSON.parse(response.data);
        if (data > 0) {
            let request = {
                ServiceID: MATM_Onboarding,
                Charge: data
            };
            setConfirmAlertRequest(request);
            setIsAlertOpen(true);
        } else {
            selectUser();
        }
    };
    const DeductCharge = async () => {
        var requestObj = {
            ServiceID: MATM_Onboarding
        };
        var request = JSON.stringify(requestObj);
        const response = await DEDUCT_CHARGE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        selectUser();
    };

    const selectUser = async () => {
        var request = JSON.stringify();
        setLoadingOpen(true);
        const response = await USER_SELECT_BY_USER_ID(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setUserObj({
            UserID: data.UserID,
            Name: data.PersonName,
            ShopName: data.FirmName,
            City: data.CityName,
            PinCode: data.Pincode,
            Email: data.EmailID,
            Address: data.Address,
            MobileNumber: data.MobileNumber,
            PanNumber: data.PANNo,
            AadhaarNumber: data.AadharNo
        });
    };

    useEffect(() => {
        setLoadingOpen(true);
        getCharge();
    }, []);

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        setLoading(true);
        var requestObj = JSON.stringify(values);
        var response = await USER_ONBORDING(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        if (!response.status) {
            setLoading(false);
            setSubmitting(false);
            setSeverity('error');
            return;
        }
        setSubmitting(false);
        resetForm(UserObj);
        let param = {
            MerchantCode: response.MerchantCode
        };
        history.push('/MP_EKYOTP', param);
    };

    const RegistrationScheama = Yup.object({
        Name: Yup.string().required('Please enter valid name'),
        ShopName: Yup.string().required('Please enter valid shop name '),
        City: Yup.string().required('Please enter valid city name '),
        PinCode: Yup.string().required('Please enter valid pin code '),
        MobileNumber: Yup.string()
            .length(10, 'Please enter valid mobile number')
            .required('Required'),
        Email: Yup.string().required('Please enter valid email address'),
        Address: Yup.string().required('Please enter valid address'),
        PanNumber: Yup.string().required('Please enter valid pan number'),
        AadhaarNumber: Yup.string().required('Please enter valid pan number')
    });

    const UploadForm = (formProps) => {
        return (
            <Form>
                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="Name"
                                    name="Name"
                                    type="text"
                                    title="Name"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="Shop Name"
                                    name="ShopName"
                                    type="text"
                                    title="Shop Name"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialNumberField
                                    label="Mobile Number"
                                    name="MobileNumber"
                                    type="text"
                                    length={10}
                                    title="Mobile Number"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="Email"
                                    name="Email"
                                    type="text"
                                    title="Email"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="Address"
                                    name="Address"
                                    type="TextArea"
                                    title="Address"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="Area"
                                    name="Area"
                                    type="TextArea"
                                    title="Area"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="CityName"
                                    name="City"
                                    type="text"
                                    title="CityName"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialNumberField
                                    label="Pin code"
                                    name="PinCode"
                                    type="text"
                                    length={6}
                                    title="Pin code"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="PAN Number"
                                    name="PanNumber"
                                    type="text"
                                    length={10}
                                    title="PAN Number"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <MaterialTextField
                                    label="Aadhar Number"
                                    name="AadhaarNumber"
                                    type="text"
                                    title="Aadhar Number"
                                    readOnly
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <label>Pan Image</label>
                                <TextField
                                    id="file"
                                    name="PanDocument"
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setPanImage(URL.createObjectURL(file));

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'PanDocument.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'PanDocument.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'PanDocument.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'PanDocument.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <img
                                    name="PanImage"
                                    src={PanImage}
                                    height={60}
                                    width={80}
                                    alt={PanImage}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <label>Aadhaar Front Image</label>
                                <TextField
                                    id="file"
                                    name="AadhaarFrontDocument"
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setAadhaarFrontImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'AadhaarFrontDocument.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'AadhaarFrontDocument.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'AadhaarFrontDocument.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'AadhaarFrontDocument.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <img
                                    name="AadhaarFrontImage"
                                    src={AadhaarFrontImage}
                                    height={60}
                                    width={80}
                                    alt={AadhaarFrontImage}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <label>Aadhaar Back Image</label>
                                <TextField
                                    id="file"
                                    name="AadhaarBackDocument"
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={(e) => {
                                        var file = e.target.files[0];

                                        setAadhaarBackImage(
                                            URL.createObjectURL(file)
                                        );

                                        var reader = new FileReader();
                                        formProps.setFieldValue(
                                            'AadhaarBackDocument.Name',
                                            file.name
                                        );
                                        formProps.setFieldValue(
                                            'AadhaarBackDocument.Size',
                                            file.size
                                        );
                                        formProps.setFieldValue(
                                            'AadhaarBackDocument.Type',
                                            file.type
                                        );
                                        reader.onload = function (item) {
                                            formProps.setFieldValue(
                                                'AadhaarBackDocument.Data',
                                                item.target.result
                                                    .replace('data:', '')
                                                    .replace(/^.+,/, '')
                                            );
                                        };

                                        reader.readAsDataURL(file);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <img
                                    name="AadhaarBackImage"
                                    src={AadhaarBackImage}
                                    height={60}
                                    width={80}
                                    alt={AadhaarBackImage}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid className={classes.footerGrid}>
                    <Box className={classes.flexReverse}>
                        <div className={classes.SubmitWrapper}>
                            <Button
                                type="submit"
                                title="submit"
                                className={classes.CustomPrimaryButtonStyle}
                                disabled={loading}
                            >
                                Submit
                            </Button>
                            {loading && (
                                <CircularProgress
                                    size={24}
                                    className={classes.buttonProgress}
                                />
                            )}
                        </div>
                        <Button
                            type="reset"
                            title="Reset"
                            className={classes.CustomDangerButtonStyle}
                        >
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Form>
        );
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={UserObj}
                validationSchema={RegistrationScheama}
                onSubmit={submithandle}
                resetForm={UserObj}
            >
                {UploadForm}
            </Formik>
            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="MATM"
                    message="Are you sure to do onbording?"
                    request={confirmAlertRequest}
                    positiveButtonClick={() => {
                        setIsAlertOpen(false);
                        DeductCharge();
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
